import { PinMap as PinMapIcon } from '@ahamove/icons/map';
import { useMapControl } from '@ahm/react-map/store';
import { Text, Button, rem } from '@mantine/core';
import { createTranslations, locales } from '../locales';
import type { BaseAddressAutocompleteProps } from '../types';

type PinMapItemProps = Pick<BaseAddressAutocompleteProps, 'pointType' | 'lang'>;

const PinMapItem = ({ lang = 'vi', pointType }: PinMapItemProps) => {
  const showPinMap = useMapControl.use.showPinMap();
  const t = createTranslations({ locales, lang });

  return (
    <Button
      leftSection={<PinMapIcon width={22} height={22} />}
      w="100%"
      mih={44}
      size="md"
      pos="fixed"
      left={0}
      bottom={0}
      bg="white"
      px={rem(14)}
      styles={{
        root: {
          boxShadow: '0px -2px 4px 0px rgba(0, 0, 0, 0.10)',
        },
        inner: {
          justifyContent: 'flex-start',
          gap: rem(4),
        },
      }}
      onClick={() => showPinMap(pointType === 'pickup' ? 0 : 1)}
    >
      <Text component="div" c="primary.7" size="sm" fw={600} lineClamp={1}>
        {t('choose_from_map')}
      </Text>
    </Button>
  );
};

export default PinMapItem;
